(function () {
  const BP = '(min-width: 750px)';
  const mq =
    typeof window.matchMedia === 'function' ? window.matchMedia(BP) : null;

  /**
   * @param {HTMLElement} root
   */
  function initCurationsSwiper(root) {
    const swiperEl = root.querySelector('.wf-curations__swiper');
    if (!swiperEl || typeof window.Swiper !== 'function') return;

    const prev = swiperEl._wfCurationsSwiper;
    if (prev && typeof prev.destroy === 'function') {
      try {
        prev.destroy(true, true);
      } catch (_) {}
      swiperEl._wfCurationsSwiper = null;
    }

    if (mq && mq.matches) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    const count = slides.length;
    if (count === 0) return;

    const loop = count > 1;

    swiperEl._wfCurationsSwiper = new window.Swiper(swiperEl, {
      loop,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 12,
      watchOverflow: true,
      observer: true,
      observeParents: true,
    });
  }

  function initAll() {
    document.querySelectorAll('[data-wf-curations]').forEach(initCurationsSwiper);
  }

  function onResize() {
    document.querySelectorAll('[data-wf-curations]').forEach(initCurationsSwiper);
  }

  let resizeTimer;
  function debouncedResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(onResize, 150);
  }

  if (!window.__wfSectionCurationsListenersBound) {
    window.__wfSectionCurationsListenersBound = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    window.addEventListener('resize', debouncedResize);

    if (mq && mq.addEventListener) {
      mq.addEventListener('change', onResize);
    } else if (mq && mq.addListener) {
      mq.addListener(onResize);
    }

    /** Teleported inline curations live outside `#shopify-section-*`; refresh all roots. */
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-wf-curations]').forEach(initCurationsSwiper);
    });
  } else if (document.readyState !== 'loading') {
    initAll();
  }
})();
